/**
 * Los contadores por estado de las pantallas de resultados de evaluacion: la
 * de proyectos y la de hojas de vida.
 *
 * Las dos pantallas comparten el hook useProyectos, que carga los datos con
 * dos consultas distintas y cada una escribe el aceptado de otra forma:
 * "Aceptado" en proyectos y "Aceptó" en hojas de vida. El chip agrupa las dos
 * grafias, asi que sirve igual en ambas y ninguna fila se cuenta dos veces,
 * porque una fila trae una sola de las dos.
 *
 * Los numeros se cuentan sobre la lista que se esta mostrando. Antes venian de
 * unos contadores del hook que la carga inicial no actualiza: al entrar, la
 * tabla traia filas y los contadores seguian todos en cero hasta que alguien
 * tocara Buscar.
 */
import { ChipEstado, contarPorChip, filtrarPorChip } from "./chipsEstado";

export type { ChipEstado } from "./chipsEstado";
export { colorDeFondo } from "./chipsEstado";

/** En los resultados el estado vive en este campo. */
const CAMPO = "estado";

/** El chip que no filtra nada; tambien es el estado inicial de la pantalla. */
export const CLAVE_TODAS = "total";

export const CHIPS_ESTADO_RESULTADO: ChipEstado[] = [
  {
    clave: "evaluado",
    etiqueta: "Evaluado",
    estados: ["Evaluado"],
    clase: "font-color-6435C9",
    claseNumero: "font-color-6435C9",
    color: "#6435C9",
  },
  {
    clave: "porEvaluar",
    etiqueta: "Por evaluar",
    estados: ["Por evaluar"],
    clase: "font-color-F28C02",
    claseNumero: "font-color-F28C02",
    color: "#F28C02",
  },
  {
    // Las dos grafias del mismo estado, segun la consulta que haya cargado.
    clave: "aceptado",
    etiqueta: "Aceptado",
    estados: ["Aceptado", "Aceptó"],
    clase: "font-color-00904C",
    claseNumero: "font-color-00904C",
    color: "#00904C",
  },
  {
    clave: "beneficiarios",
    etiqueta: "Beneficiarios",
    estados: ["Beneficiario"],
    clase: "font-color-00904C",
    claseNumero: "font-color-00904C",
    color: "#00904C",
  },
  {
    clave: CLAVE_TODAS,
    etiqueta: "Total",
    estados: null,
    clase: "",
    claseNumero: "font-color-F28C02",
    color: "#F28C02",
  },
];

/** Los proyectos que le corresponden a un chip. */
export const proyectosDelChip = (
  proyectos: any[],
  clave?: string | null
): any[] => filtrarPorChip(proyectos, CHIPS_ESTADO_RESULTADO, clave, CAMPO);

/** Cuantos proyectos le corresponden a un chip. */
export const contarChipResultado = (
  proyectos: any[],
  clave?: string | null
): number => contarPorChip(proyectos, CHIPS_ESTADO_RESULTADO, clave, CAMPO);
